// extracted by mini-css-extract-plugin
export default {"contents":"QD-z","sectionHeading":"RD-z"};